import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { sx } from "./styles/PartialSuccessModal.styles";

interface Props {
  open: boolean;
  createdUsernames: string[];
  onClose: () => void;
}

const PartialSuccessModal: FC<Props> = ({
  open,
  createdUsernames,
  onClose,
}) => {
  const [t] = useTranslation("global");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {t("Create_site.config_users.partial_success_title")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {t("Create_site.config_users.partial_success_desc")}
        </Typography>
        <List dense disablePadding>
          {createdUsernames.map((username) => (
            <ListItem key={username} disableGutters>
              <ListItemIcon sx={sx.listItemIcon}>
                <CheckCircleOutlineIcon color="success" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={username} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={sx.closeButton}>
          {t("Common_options.Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartialSuccessModal;
